import { Flex, Badge, HStack, Button } from "@chakra-ui/react";
import DocumentMonitoringTable from "./DocumentMonitoringTable";
import { ScanSearch } from "lucide-react";

const DocMonitoring = () => {
  return (
    <Flex direction="column" p={0} w={"100%"} gap={{ lg: 16, base: 8 }}>
      <Flex
        justifyContent="space-between"
        direction={{ lg: "row", base: "column" }}
        gap={4}>
        <h1>Document monitoring</h1>
        <HStack>
          <Badge size={"sm"}>Last scan: Today, 8:00</Badge>
          <Button size={"md"}  leftIcon={<ScanSearch />}>
            Scan now
          </Button>{" "}
        </HStack>
      </Flex>

      <DocumentMonitoringTable />
    </Flex>
  );
};

export default DocMonitoring;
